import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import HoroScopeClient from '@/api/horoScope';
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { horoscopeIdex } from "@/utils/horoscopeUtil";

var GetHoroscopeFates =
/*#__PURE__*/
function () {
  function GetHoroscopeFates() {
    _classCallCheck(this, GetHoroscopeFates);

    this.horoId = 0;
  }

  _createClass(GetHoroscopeFates, [{
    key: "getFates",
    value: function getFates(isshowloading) {
      var _this = this;

      this.horoId = horoscopeIdex[store.getters[types.GETTER_HOROSCOPE]];
      this.getTodayFate(isshowloading);
      setTimeout(function () {
        _this.getTomorrowFate();

        _this.getWeekFate();

        _this.getMonthFate();

        _this.getYearFate();
      }, 1000);
    }
  }, {
    key: "getTodayFate",
    value: function () {
      var _getTodayFate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(val) {
        var todayFate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return HoroScopeClient.req_horo_today(this.horoId);

              case 2:
                todayFate = _context.sent;

                if (todayFate && todayFate.status === 200) {
                  store.commit(types.UPDATE_TODAY_HOROSCOPE_FATE, JSON.parse(todayFate.data));

                  if (val) {
                    store.dispatch(types.ROUTER_REPLACE, {
                      name: "horoscopePage",
                      query: {
                        token: 'today'
                      },
                      params: {
                        routerTransition: "forward",
                        changeSlide: true
                      }
                    });
                  }
                }

                store.commit(types.UPDATE_LOADING_STATUS, false);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTodayFate(_x) {
        return _getTodayFate.apply(this, arguments);
      }

      return getTodayFate;
    }()
  }, {
    key: "getTomorrowFate",
    value: function () {
      var _getTomorrowFate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var tomorrowFate;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return HoroScopeClient.req_horo_tomorrow(this.horoId);

              case 2:
                tomorrowFate = _context2.sent;

                if (tomorrowFate && tomorrowFate.status === 200) {
                  store.commit(types.UPDATE_TOMORROW_HOROSCOPE_FATE, JSON.parse(tomorrowFate.data));
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTomorrowFate() {
        return _getTomorrowFate.apply(this, arguments);
      }

      return getTomorrowFate;
    }()
  }, {
    key: "getWeekFate",
    value: function () {
      var _getWeekFate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var weekFate;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return HoroScopeClient.req_horo_week(this.horoId);

              case 2:
                weekFate = _context3.sent;

                if (weekFate && weekFate.status === 200) {
                  store.commit(types.UPDATE_WEEK_HOROSCOPE_FATE, JSON.parse(weekFate.data));
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getWeekFate() {
        return _getWeekFate.apply(this, arguments);
      }

      return getWeekFate;
    }()
  }, {
    key: "getMonthFate",
    value: function () {
      var _getMonthFate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var monthFate;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return HoroScopeClient.req_horo_month(this.horoId);

              case 2:
                monthFate = _context4.sent;

                if (monthFate && monthFate.status === 200) {
                  store.commit(types.UPDATE_MONTH_HOROSCOPE_FATE, JSON.parse(monthFate.data));
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getMonthFate() {
        return _getMonthFate.apply(this, arguments);
      }

      return getMonthFate;
    }()
  }, {
    key: "getYearFate",
    value: function () {
      var _getYearFate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var yearFate;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return HoroScopeClient.req_horo_year(this.horoId);

              case 2:
                yearFate = _context5.sent;

                if (yearFate && yearFate.status === 200) {
                  store.commit(types.UPDATE_YEAR_HOROSCOPE_FATE, JSON.parse(yearFate.data));
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getYearFate() {
        return _getYearFate.apply(this, arguments);
      }

      return getYearFate;
    }()
  }]);

  return GetHoroscopeFates;
}();

export default new GetHoroscopeFates();